//
//
//
//
//
//
//
//
//
//
//
//

import TopHeader from './_header.vue'
import NormalTools from './normal_tools.vue'
import OtherTools from './other_tools.vue'
import { App_User } from '@/data/user_info'
import care from './care'
export default {
    mixins: [
        care
    ],
    data () {
        return {
            user: {}
        }
    },
    computed: {
        is_login () {
            return this.user && this.user.tag_list && this.user.tag_list.indexOf('天府通游客') === -1
        }
    },
    components: {
        TopHeader,
        NormalTools,
        OtherTools
    },
    mounted () {
        App_User.get().then((user) => {
            this.user = user
            this.initCareMsg()
        })
    }
}
